export default "__VITE_ASSET__4735aaa4__"